import type {
  SettingsPageContextProps,
  SettingsPageContextServices,
} from '../../../types';
import { fetchCurrentMember } from '../viewer-controller/state';
import {
  handleNavigation,
  redirectTo404,
  redirectToErrorPage,
} from './navigation';
import {
  addInitialDataForWidgetPlugins,
  emitMemberChangedEventToPlugins,
} from './widget-plugins';

export const addLocationChangeHandler = (
  contextProps: SettingsPageContextProps,
  contextServices: SettingsPageContextServices,
) => {
  return contextProps.wixCodeApi.location.onChange(async () => {
    const { stateId } = contextServices.routeDataService.getRouteData();

    let hasMemberChanged = false;

    try {
      const data = await fetchCurrentMember(contextProps, contextServices);
      hasMemberChanged = data.hasMemberChanged;
    } catch (error) {
      contextServices.monitoringService.reportError(error as Error);
      return redirectToErrorPage(contextProps, contextServices, error);
    }

    if (!stateId) {
      return redirectTo404(
        contextServices.multiStateBoxService,
        contextServices.errorStateService,
      );
    }

    if (hasMemberChanged) {
      addInitialDataForWidgetPlugins(contextProps, contextServices);
      await emitMemberChangedEventToPlugins(contextProps, contextServices);
    }

    await contextServices.widgetPluginHostService.membersAreaWidgetReady();
    await contextServices.multiStateBoxService.showMainAppState();

    return handleNavigation(contextProps, contextServices);
  });
};
